import React from 'react'
import { Grid } from '@material-ui/core'
import DatePicker from '../../../../control/datepicker/datepicker'
import Autocomplete from '../../../../control/autocomplete/autocomplete'
import MyTextfield from '../../../../control/textfield/textfield'
import MyAccordion from '../../../../control/accordion/accordion'
import useTranslate from '../../../../i18n/useTranslate'
import { validateMaxDocLength, validateNumeralNoPrecision } from '../../../../utilities/validate'
import * as numberOfDocTypes from './numberOfDocTypes'
import useNumberOfDoc from './useNumberOfDoc'
import { getDisable, getRequire } from '../../shareLogic/useFunctionHook'

//View
const NumberOfDocView = (props: numberOfDocTypes.NumberOfDocViewType) => {
    const { condition, onChangRequireDoc, disabledFieldNames, requiredFieldNames } = props
    const translate = useTranslate()

    return (
        <React.Fragment>
            <MyAccordion title={translate.get('LABEL.SPECIFY_ADDITIONAL_DOC_TO_SENT')}>
                <Grid container item justify="flex-start" spacing={2}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Autocomplete
                            name="requireDoc"
                            materialInputProps={{
                                label: translate.get('LABEL.REQUIRE_SENT_DOC'),
                                placeholder: translate.get('LABEL.PLEASE_SELECT'),
                                disabled: getDisable('requireDoc', disabledFieldNames),
                                required: getRequire('requireDoc', requiredFieldNames),
                            }}
                            options={condition}
                            required
                            onChangeValue={onChangRequireDoc}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <MyTextfield
                            name="documentNumber"
                            materialInputProps={{
                                label: translate.get('LABEL.NUMBER_OF_DOC_TO_SENT'),
                                placeholder: '',
                                size: 'small',
                                disabled: getDisable('documentNumber', disabledFieldNames),
                            }}
                            type={'number'}
                            min={1}
                            maxLength={3}
                            required={getRequire('documentNumber', requiredFieldNames)}
                            validates={[
                                validateNumeralNoPrecision(translate.get('MESSAGE.M005')),
                                validateMaxDocLength(translate.get('MESSAGE.M029', ['999'])),
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <DatePicker
                            name="sendDocumentDate"
                            label={translate.get('LABEL.DOC_SUBMITTED_DEADLINE')}
                            minDate={new Date()}
                            disabled={getDisable('sendDocumentDate', disabledFieldNames)}
                            required={getRequire('sendDocumentDate', requiredFieldNames)}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <MyTextfield
                            name="remark"
                            materialInputProps={{
                                label: translate.get('LABEL.REMARK'),
                                placeholder: translate.get('LABEL.FILL_REMARK'),
                                size: 'small',
                                rows: 5,
                                multiline: true,
                                disabled: getDisable('remark', disabledFieldNames),
                            }}
                            required={getRequire('remark', requiredFieldNames)}
                            maxLength={1000}
                        />
                    </Grid>
                </Grid>
            </MyAccordion>
        </React.Fragment>
    )
}

//Controller
const NumberOfDoc = (props: numberOfDocTypes.NumberOfDocType) => {
    const numberOfDocModel = useNumberOfDoc(props)
    return <NumberOfDocView {...numberOfDocModel} {...props} />
}

export default NumberOfDoc
